import { useNavigate, useParams } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { getAlimento } from "../../db/queries";
import { dataHora } from "../../lib/format";
import { PASSO_ESCADA_LABEL } from "../../types";
import { editarNota, excluirNota, getNota, getProfissional } from "../queries";
import { TIPO_ANEXO_LABEL } from "../types";
import { EspecialidadeBadge } from "../ui/EspecialidadeBadge";

export function DetalheNota() {
  const { id = "" } = useParams();
  const nav = useNavigate();
  const nota = useLiveQuery(() => getNota(id), [id]);
  const prof = useLiveQuery(
    async () => (nota ? await getProfissional(nota.profissional_id) : undefined),
    [nota?.profissional_id],
  );
  const alimento = useLiveQuery(
    async () => (nota?.alimento_id ? await getAlimento(nota.alimento_id) : undefined),
    [nota?.alimento_id],
  );

  if (!nota) {
    return (
      <main className="tela">
        <button className="btn btn-fantasma" onClick={() => nav(-1)}>← voltar</button>
        <div className="vazio">nota não encontrada.</div>
      </main>
    );
  }

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>← voltar</button>

      <div className="row" style={{ margin: "var(--s2) 0 var(--s4)" }}>
        <EspecialidadeBadge especialidade={nota.especialidade} />
        <div className="crescer">
          <div className="nome">{prof?.nome ?? "profissional"}</div>
          <div className="meta" style={{ color: "var(--text-muted)" }}>{dataHora(nota.data_sessao)}</div>
        </div>
      </div>

      <section className="secao">
        <h2 className="secao-titulo">objetivo</h2>
        <div className="card">
          <input
            type="text"
            value={nota.objetivo}
            onChange={(e) => editarNota(id, { objetivo: e.target.value })}
            style={{ width: "100%", minHeight: "var(--touch)", padding: "var(--s3)", border: "1px solid var(--border-forte)", borderRadius: "var(--r-sm)", background: "var(--surface)", color: "var(--text)", font: "inherit" }}
          />
        </div>
      </section>

      {(nota.degrau_observado !== null || alimento) && (
        <section className="secao">
          <h2 className="secao-titulo">resultado na escada</h2>
          <div className="card">
            {alimento && <div style={{ fontWeight: 500 }}>{alimento.nome}</div>}
            <div className="meta" style={{ color: "var(--text-muted)" }}>
              {nota.degrau_observado !== null ? `observado: ${PASSO_ESCADA_LABEL[nota.degrau_observado]}` : "sem degrau observado"}
              {nota.degrau_alvo !== null ? ` · alvo: ${PASSO_ESCADA_LABEL[nota.degrau_alvo]}` : ""}
            </div>
            {nota.oferta_id_gerada && (
              <p className="status-regra" style={{ marginTop: "var(--s2)" }}>
                ✓ gerou uma oferta de terapia (a escada do alimento foi atualizada).
              </p>
            )}
          </div>
        </section>
      )}

      {nota.atividades.length > 0 && (
        <section className="secao">
          <h2 className="secao-titulo">atividades</h2>
          <div className="chips">
            {nota.atividades.map((a, i) => <span className="chip" key={i}>{a}</span>)}
          </div>
        </section>
      )}

      <section className="secao">
        <h2 className="secao-titulo">orientações para casa</h2>
        <div className="card">
          <textarea
            value={nota.orientacoes_casa ?? ""}
            onChange={(e) => editarNota(id, { orientacoes_casa: e.target.value || null })}
            placeholder="o que a família aplica até a próxima sessão"
            style={{ width: "100%", minHeight: 72, padding: "var(--s3)", border: "1px solid var(--border-forte)", borderRadius: "var(--r-sm)", background: "var(--surface)", color: "var(--text)", font: "inherit", resize: "vertical" }}
          />
        </div>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">observações clínicas</h2>
        <div className="card">
          <textarea
            value={nota.observacoes ?? ""}
            onChange={(e) => editarNota(id, { observacoes: e.target.value || null })}
            placeholder="observações; @menção de colega vira pedido rastreável na Fase 2"
            style={{ width: "100%", minHeight: 72, padding: "var(--s3)", border: "1px solid var(--border-forte)", borderRadius: "var(--r-sm)", background: "var(--surface)", color: "var(--text)", font: "inherit", resize: "vertical" }}
          />
        </div>
      </section>

      {nota.anexos.length > 0 && (
        <section className="secao">
          <h2 className="secao-titulo">anexos</h2>
          <div className="card">
            {nota.anexos.map((a, i) => (
              <div className="row-entre" key={i} style={{ padding: "4px 0" }}>
                <span>{a.tipo === "audio" ? "🎙️" : a.tipo === "video" ? "🎬" : a.tipo === "foto" ? "🖼️" : "📄"} {TIPO_ANEXO_LABEL[a.tipo]}</span>
                {a.sensibilidade === "restrito_anel"
                  ? <span className="badge badge-recusado"><span className="glifo" aria-hidden>🔒</span> sensível · fora do export</span>
                  : <span className="meta" style={{ color: "var(--text-suave)" }}>normal</span>}
              </div>
            ))}
          </div>
        </section>
      )}

      <button
        className="btn btn-bloco"
        style={{ marginTop: "var(--s4)", color: "var(--text-muted)" }}
        onClick={async () => {
          if (!window.confirm("excluir esta nota de sessão?")) return;
          await excluirNota(id);
          nav(-1);
        }}
      >
        excluir nota
      </button>
    </main>
  );
}
